import "./index.style.scss";
import { localStrings } from "src/utils/localization";
import { useRouter } from "src/hooks/useRouter";
import { useModal } from "src/hooks/useModal";
import { userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { openPrivatePolicy, openTermsService, openPaidTermsService } =
    useModal();
  const { goToBlog, goToYoutube, goToFacebook, goToInsta, goTerms } =
    useRouter();

  const YEAR = new Date().getFullYear();
  const { i18n, t } = useTranslation();
  const languageCode = i18n.language;
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { isOciProduct } = useIsOciProduct();
  const { changeLang } = useRouter();
  // const toggleLanguage = () => {
  //   const newLang = i18n.language === "ko" ? "en" : "ko";
  //   i18n.changeLanguage(newLang);
  // };
  return (
    <footer className="footer">
      <div className="footer-container">
        <section className="footer-menu">
          <div className="footer-menu-left">
            <ul>
              <li>{`ⓒ Fasoo ${YEAR}`}</li>
              {/* <li onClick={openTermsService}> */}
              <li onClick={languageCode === "ko" ? goTerms : openTermsService}>
                {t("logIn.signUp.agreement2")}
              </li>
              <li onClick={openPrivatePolicy}>{t("siteType.agreement4")}</li>
              {/* 유료 이용약관 */}
              {/* {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" && (
              <li onClick={openPaidTermsService}>
                {t("siteType.tab3")}
              </li>
            )} */}
              {/* <li>유료 이용약관</li> */}
            </ul>
          </div>
          <div className="footer-menu-right">
            <ul>
              {!isOciProduct && (
                <li>
                  <div className="internetIcon" onClick={changeLang} />
                </li>
              )}
              {languageCode === "ko" && (
                <li>
                  <div className="blogIcon" onClick={goToBlog} />
                </li>
              )}
              <li>
                <div className="youtubeIcon" onClick={goToYoutube} />
              </li>
              <li>
                <div className="facebookIcon" onClick={goToFacebook} />
              </li>
              <li>
                <div className="instaIcon" onClick={goToInsta} />
              </li>
            </ul>
          </div>
        </section>
        {languageCode === "ko" && (
          <section className="footer-description">
            <p>주식회사 파수 | 대표이사 조규곤 | 사업자등록번호 1208606582</p>
            <p>
              주소: 서울특별시 마포구 월드컵북로 396 (상암동 1605, 누리꿈스퀘어
              비즈니스타워 17층) 03925 | 전화번호: 02-300-9261 | 전자우편주소:
              cloud@fasoo.com
            </p>
          </section>
        )}
      </div>
    </footer>
  );
};

export default Footer;
